import React, { FunctionComponent, useMemo } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ResponseState } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';
import { isPending, isPendingPublish } from 'reviews2/feed/review-yeti/reply/ReviewReply.util';

export const ReplyPending: FunctionComponent<{ reply: any }> = ({ reply }) => {
    const { t } = useTranslation('reviews2');
    const message = useMemo(() => {
        switch (reply.responseState) {
            case ResponseState.PendingApproval:
                return {
                    tooltip: t('PENDING_APPROVAL_TOOLTIP'),
                    text: t('PENDING_APPROVAL'),
                };
            case ResponseState.PendingModeration:
                return {
                    tooltip: t('PENDING_MODERATION_TOOLTIP'),
                    text: t('PENDING_MODERATION'),
                };
            case ResponseState.PendingPublish:
                return {
                    tooltip: t('PENDING_PUBLISH_TOOLTIP'),
                    text: t('PENDING_PUBLISH'),
                };
            case ResponseState.PendingManual:
                return {
                    tooltip: t('PENDING_MANUAL_TOOLTIP'),
                    text: t('PENDING_MANUAL'),
                };
            default:
                return null;
        }
    }, [reply, t]);

    if (!isPending(reply) && !isPendingPublish(reply)) {
        return null;
    }

    return (
        <span className="reply-pending">
            <OverlayTrigger overlay={<Tooltip id={reply.document_id}>{message?.tooltip}</Tooltip>}>
                <i className="icon-hourglass" />
            </OverlayTrigger>
            {message?.text}
        </span>
    );
};
